import i18n from '@/libs/i18n'

const { t } = i18n.global

enum Errors {
    InternalServerError = 1,
    InvalidData,
    NotFound,
    Unauthorized,
    UserExist,
    UserDoesNotExist,
    RoleExists,
    RoleDoesNotExist,
    UnableToRetrieveExtension,
    FileToBig,
    MissingRoles,
    IncorrectPassword,
    ErrFetchingData,
    ErrDeletingDefaultData,
    DataAlreadyExists,
    FailedToInsert,
    ErrClientDoesNotExist,
    ErrUsernameExists,
    ErrEmailExist
}

const parseError = (errorObject: unknown, fallback = '') => {
    if (errorObject === null || errorObject === undefined
        || !(errorObject instanceof Object)
        || !('error' in errorObject)
        || !errorObject.error
        || !(errorObject.error instanceof Object)
        || !('code' in errorObject.error)
        || errorObject.error.code === Errors.InternalServerError) {
        if (fallback && fallback !== '') return fallback
        return t('errors.generic_error')
    }

    switch (errorObject.error.code) {
        case Errors.InvalidData:
            return t('errors.invalid_data')
        case Errors.NotFound:
            return t('errors.not_found')
        case Errors.Unauthorized:
            return t('errors.unauthorized')
        case Errors.UserExist:
            return t('errors.user_exist')
        case Errors.UserDoesNotExist:
            return t('errors.user_does_not_exist')
        case Errors.RoleExists:
            return t('errors.role_exists')
        case Errors.RoleDoesNotExist:
            return t('errors.role_does_not_exist')
        case Errors.UnableToRetrieveExtension:
            return t('errors.unable_to_retrieve_extension')
        case Errors.FileToBig:
            return t('errors.file_to_big')
        case Errors.MissingRoles:
            return t('errors.missing_roles')
        case Errors.IncorrectPassword:
            return t('errors.incorrect_password')
        case Errors.ErrFetchingData:
            return t('errors.fetching_data')
        case Errors.ErrDeletingDefaultData:
            return t('errors.deleting_default_data')
        case Errors.DataAlreadyExists:
            return t('errors.data_already_exists')
        case Errors.FailedToInsert:
            return t('errors.failed_to_insert')
        case Errors.ErrClientDoesNotExist:
            return t('errors.client_does_not_exist')
        case Errors.ErrUsernameExists:
            return t('errors.username_exists')
        case Errors.ErrEmailExist:
            return t('errors.email_exists')
        default:
            return t('errors.generic_error')
    }
}

export { parseError }
